import { render } from "./PastDueModal.vue?vue&type=template&id=68189882&scoped=true"
import script from "./PastDueModal.vue?vue&type=script&lang=js"
export * from "./PastDueModal.vue?vue&type=script&lang=js"

import "./PastDueModal.vue?vue&type=style&index=0&id=68189882&scoped=true&lang=css"

import exportComponent from "/Users/numeria/Desktop/innopearl-partner-plus/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68189882"]])

export default __exports__